import './Daily-video.css'
import * as React from 'react'
import VodList from './vod-list/VodList'
import { DailyVodConfig } from '../../configs/stream-entities'
import VodDetail from './vod-detail/VodDetail';
import VideoCategories from './categories/Video-categories';
import {css, StyleSheet} from "aphrodite";

class DailyVideoState {
    public selectedId: string
}

class DailyVideo extends React.Component<any, DailyVideoState> {
    constructor(props: any) {
        super(props)
        this.state = new DailyVideoState()
        this.showDetails = this.showDetails.bind(this)
    }

    public render() {
        return (<div className="daily-video">
            <h2>Categories</h2>
            <VideoCategories/>
            <div className={css(styles.videoSection)}>
                <h2>Videos</h2>
                <div className={css(styles.videoContainer)}>
                    <VodList onItemSelected={this.showDetails} isMultiple={true} defaultValue={""} />
                    <VodDetail vodId={this.state.selectedId} />
                </div>
            </div>

        </div>)
    }

    private showDetails(clss: DailyVodConfig) {
        this.setState({ selectedId: clss.id })
    }
}


const styles = StyleSheet.create({
    videoSection: {
        paddingTop: "20px",
        backgroundColor: "#F9F9F9"
    },
    videoContainer: {
        display: 'flex',
        justifyContent: 'space-evenly',
    },
});

export default DailyVideo


// WEBPACK FOOTER //
// ./src/components/daily-video/Daily-video.tsx